export const SET_CORPORATION_COMMON_QUESTIONS =
  "SET_CORPORATION_COMMON_QUESTIONS";
export const SET_VENTURE_MESSAGES = "SET_VENTURE_MESSAGES";
